import React from 'react'
import { AIQualityCheckPlanDetailItem } from 'src/types/ai-quality-check'
import { translateToFormValues } from '../../quality-check-scheme-detail/components/utils'

const PreviewMoc = ({ qcPlanDetail }: { qcPlanDetail: AIQualityCheckPlanDetailItem | null }) => {
  const translatedData = translateToFormValues(qcPlanDetail)
  return (
    <div style={{ paddingLeft: 10 }}>
      {translatedData?.nodeResults?.map((item, index) => (
        <div key={index} style={{ paddingTop: 10 }}>
          <div style={{ display: 'flex' }}>
            <span>
              板块:{item.moduleName}
            </span>
          </div>
          {item?.items?.map((subItem, subIndex) => (
            <div key={subIndex} className="rule-container">
              <span style={{ marginRight: '10px', marginTop: '6px' }}>
                <span>
                  评分项{subIndex + 1}:{subItem?.name}（{subItem?.scoreRangeMax}分）
                </span>
              </span>
              <div style={{ display: 'inline-block', width: 'calc(100% - 10px)' }}>
                <div style={{ paddingLeft: 10 }}>
                  <div style={{ display: 'flex' }}>
                    <span style={{ width: 65, flex: '0 0 65px' }}>具体描述:</span>
                    <span>
                      {subItem?.description}
                    </span>
                  </div>
                  <div>
                    <span style={{ width: 65, flex: '0 0 65px' }}>评分细则:</span>
                    <ul style={{ paddingLeft: 10 }}>
                      {subItem?.subItems?.map((subSubItem, subSubIndex) => (
                        <li key={subSubIndex}>
                          <p>
                            {subSubItem?.scoreRangeMin === subSubItem?.scoreRangeMax ? `${subSubItem?.scoreRangeMin}分:${subSubItem?.description}` : `${subSubItem?.scoreRangeMin}-${subSubItem?.scoreRangeMax}分:${subSubItem?.description}`}
                          </p>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      ))}
    </div>
  )
}

export default PreviewMoc
